export default __webpack_public_path__ + "static/media/la1.1.71b919fb.png";